import React, { useRef, useState, useEffect } from "react";
import * as echarts from "echarts";

const BarHorizontalGraph = ({ option }) => {
  const refBar = useRef();
  const [render, setrender] = useState(false);
  const formatTitle = (title) => {
    return (title + " ").replace(/(\S(.{0,60}\S)?)\s+/g, "$1\n").trim();
  };
  useEffect(() => {
    let chartDom = refBar.current;
    let myChart = echarts.init(chartDom);
    let chartTitle =
      option.title.length > 60 ? formatTitle(option.title) : option.title;
    let configuration = {
      title: {
        text: chartTitle,
        subtext: option.subtitle,
        left: "center",
      },
      tooltip: {},
      xAxis: {},
      yAxis: {
        type: "category",
        data: option.dataLabels,
        inverse: true,
        animationDuration: 300,
        animationDurationUpdate: 300,
        axisLabel: {
          formatter: function (value, index) {
            if (value.length > 30) {
              return value.substr(0, 30).concat("...");
            }
            return value;
          },
        },
      },
      grid: {
        left: "3%",
        right: "14%",
        bottom: "3%",
        containLabel: true,
      },
      series: [
        {
          realtimeSort: true,
          type: "bar",
          data: option.data, //[100, 200, 300, 400],
          animationDelay: function (idx) {
            return idx * 100;
          },
          itemStyle: {
            color: "purple",
          },
          label: {
            show: true,
            position: "right",
            valueAnimation: true,
            formatter: option.formaterLegent,
            offset: [10, 0],
            color: "green",
            fontSize: 18,
          },
        },
      ],
      animationEasing: "elasticOut",
      animationDelayUpdate: function (idx) {
        return idx * 5;
      },
      legend: {
        show: true,
      },
    };

    configuration && myChart.setOption(configuration);
    setrender(!render);
  }, [option]);

  return (
    <>
      <div
        ref={refBar}
        style={{
          width: "600px",
          height: "300px",
          margin: "auto",
          marginTop: "2em",
          marginBottom: "3em",
        }}
      ></div>
    </>
  );
};

export default BarHorizontalGraph;
